import WritePattersonData from "../../../../src/components/wright-patterson-data.js";
import * as React from 'react';
export default {
  WritePattersonData,
  React
};